import React from 'react';
import { Link } from 'react-router-dom';
import useEntitlement from '../utils/useEntitlement';

/**
 * "Upgrade to <next plan> for More" call-to-action (M3 gating). Renders nothing for
 * users already on the top tier (PREMIUM). Links to the subscription plans page
 * (`/subscription`) where upgrade options are shown.
 *
 * Props:
 *   - message: optional full override text.
 *   - suffix: optional tail appended to the default ("for More" by default).
 *   - className / style: passed to the link.
 */
export default function UpgradeNudge({ message, suffix = 'for More', className = '', style }) {
    const { nextPlanLabel } = useEntitlement();
    if (!nextPlanLabel) return null; // already on the highest plan
    const text = message || `Upgrade to ${nextPlanLabel} ${suffix}`.trim();
    return (
        <Link to="/subscription" className={`btn btn-sm btn-warning ${className}`} style={style}>
            {text}
        </Link>
    );
}
